import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {
	public loading$ = new BehaviorSubject(false);
	private loadingCount = 0;
	private skipNext = false;

	/**
	 * List of requests that do not trigger the loading spinner
	 */
	private readonly skippedRequests: Record<'get' | 'delete' | 'patch' | 'put' | 'post', readonly string[]> = {
		get: ['health/live'],
		delete: [],
		post: ['/token'],
		patch: [],
		put: [],
	} as const;

	public isSkippedRequest(request: HttpRequest<any>) {
		const requestUrl = request.url.toLowerCase();
		const method = request.method.toLowerCase() as keyof typeof this.skippedRequests;
		const skippedRequests = this.skippedRequests[method] || [];

		return skippedRequests.some((url: string) => requestUrl.includes(url.toLowerCase()));
	}

	public skipNextRequest(): void {
		this.skipNext = true;
	}

	public show(): void {
		this.loadingCount++;
		if (!this.skipNext) {
			this.loading$.next(true);
		} else {
			this.skipNext = false;
		}
	}

	public hide(): void {
		this.loadingCount--;
		if (this.loadingCount <= 0) {
			this.loadingCount = 0; // Ensure count doesn't go negative, otherwise it might hide too early
			this.loading$.next(false);
		}
	}
}
